import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/guardian-link-requests", label: "申請一覧" }
];

export function AdminGuardianLinksPage() {
  return (
    <PageScaffold
      title="Admin Guardian Links"
      description="保護者紐付け一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに guardian link 一覧を表示します。</p>
    </PageScaffold>
  );
}
